module.exports = __webpack_public_path__ + "img/header-diamondJewelryGold@2x.edcbe75.webp";